import React from "react";
import {
  Banner,
  Bar,
  Entertainment,
  Footer,
  Hero,
  Location,
  Macquee,
  Menu,
  Restaurant,
  TodaysSpecialMenu,
  Welcome,
} from "../components";
import BannerStar from "../components/BannerStar";

const Home = () => {
  return (
    <main>
      <Hero />
      <Welcome />
      <Macquee />
      <div className="sm:flex hidden">
        <Banner image={"/images/banner1.png"} />
      </div>
      <div className="sm:hidden flex">
        <Banner image={"/banner-1A.jpg"} />
      </div>
      <Restaurant />
      <div className="sm:flex hidden">
        <Banner image={"/images/banner2.png"} />
      </div>
      <div className="sm:hidden flex">
        <Banner image={"/banner-2A.jpg"} />
      </div>
      <TodaysSpecialMenu />
      <div className="sm:block hidden">
        <Banner image={"/images/bar-banner.jpg"} />
      </div>
      <div className="sm:hidden block">
        <Banner image={"/banner-3A.jpg"} />
      </div>
      <Bar />
      <Banner image={"/images/banner4.png"} />
      <Entertainment />
      <Banner image={"/images/banner5.png"} />
      <Menu />
      <BannerStar image={"/images/get-banner.jpg"} />
      <Location />
      <Banner image={"/images/banner7.png"} />
      <Footer />
    </main>
  );
};

export default Home;
